import { Shot } from '@/types/greenroom/shots.types';
import { Post } from '../helpers';
import { GREENROOM_HOST } from '@/utils/connections/endpoints';

const BulkEditShots = ({ shots, deprecated = '' }: { shots: Shot[]; deprecated?: string }) => {
  const meetingId = shots?.[0].meeting ?? 0;
  return Post({
    host: GREENROOM_HOST,
    path: '/v2/greenroom/shots/bulk-edit',
    includeGreenroomToken: true,
    headers: {
      'bl-global-resource': 'false',
    },
    body: {
      shots,
      meetingId,
      deprecated,
    },
  });
};

export default BulkEditShots;
